<template>
  <v-row justify="center">
    <v-dialog v-model="active" :persistent="fix" max-width="400">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon v-if="!fix" size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{title}}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:80px; font-size:15px">
          {{content}}
        </v-card-text>
        <v-row  justify="center">          
          <v-card-actions>
            <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#81C0E2"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
        <v-card-text v-if="time" class="text-center pb-0" style="font-weight:600; font-size:12px; color:#888">
          系統時間：{{time}}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'ShowMsg',
    props:['onSave'],
    data () {
      return {
        active: false,
        title: '',
        content: '',
        time: '',
        onSaveEn: false,
        fix: false,
        info: '',
      }
    },
    methods:{
      open(type = null, title = null, content = null, onSaveEn = false, fix = false, info = null){
        this.active = true
        this.onSaveEn = onSaveEn
        this.fix = fix
        this.info = info
        if(type==0 && title=='系統錯誤'){
          this.time = this.$options.filters.dateFormat(new Date(),'YYYY-MM-DD HH:mm:ss')
        }
        switch(type){
          case 0:
          default:
            this.title = title
            this.content = content
            break
          case 1:
            this.title = '請輸入所有必填'
            this.content = '請輸入所有必填。'
            break
          case 2:
            this.title = '請聯繫管理人員'
            this.content = '如欲修改相關資訊，煩請寄信至 service@cerps.org.tw 並註明場次代碼及修改內容，或請撥打電話 03-4264248 謝謝您 !'
            break
          case 3:
            this.title = '下載次數已達上限'
            this.content = '煩請寄信至 service@cerps.org.tw 聯繫管理人員，或請撥打電話 03-4264248 謝謝您 !'
            break
          case 4:
            this.title = '已刪除資料'
            this.content = '您已刪除此筆資料 !'
            break
          //seldom use
          case 11:
            this.title = '帳號資料修改完成'
            this.content = '您的帳號資料已修改完成，謝謝。'
            break
          case 12:
            this.title = '密碼修改完成'
            this.content = '您的密碼已修改完成，下次將以新密碼登錄，謝謝。'
            break
          case 13:
            this.title = '修改密碼失敗'
            this.content = '請確認"舊密碼"是否正確。'
            break
          case 14:
            this.title = '新密碼長度不符'
            this.content = '請確認"新密碼"為4~10個英文字母或數字。'
            break
          case 15:
            this.title = '兩組新密碼不同'
            this.content = '請確認"新密碼"和"確認新密碼"相同。'
            break
          case 16:
            this.title = '基本資料不完全'
            this.content = '請至"帳號資料修改"完整填寫您的基本資料。'
            break
          case 17:
            this.title = '送出成功'
            this.content = '誠摯感謝您的詢問，我們將儘速以電子郵件回應您，謝謝。'
            break
          case 18:
            this.title = '申請成功'
            this.content = '專案認證申請成功，謝謝您 !'
            break
          case 19:
            this.title = '請聯繫管理人員'
            this.content = '就校認證如已繳費無法辦理退費，大型會考退費規定請洽官網資訊，或煩請聯繫學會03-4264248'
            break
          case 20:
            this.title = '請聯繫管理人員'
            this.content = '考試前：如需修改報名資訊，煩請寄信至 service@cerps.org.tw並註明場次代碼、姓名、欲修改內容。考試後：如需修改資訊，煩請進行申請補換發程序 謝謝您 !'
            break
          case 21:  //未接
            this.title = '請聯繫管理人員'
            this.content = '您無法於同時段報名多項考科，如有任何問題請聯繫學會 service@cerps.org.tw 或撥打電話 03-4264248 謝謝您 !'
            break
          case 22:  //未接
            this.title = '請聯繫管理人員'
            this.content = '您無法申請多份紙本證書，如有任何問題請聯繫學會 service@cerps.org.tw 或撥打電話 03-4264248 謝謝您 !'
            break
          case 23:
            this.title = '系統提示'
            this.content = '您的報考身份為減免身份，無付費收據，如有任何問題請聯繫學會 service@cerps.org.tw 或撥打電話 03-4264248 謝謝您 !'
            break
        }
      },
      close(){
        this.active = false
      },
      save(){
        if(this.onSaveEn){
          this.onSave(this.info)
        }
        this.close()
      }
    }
  }
</script>